// import { useNavigate } from 'react-router-dom';
/**
 * This file contains the client-side JavaScript code for the application.
 */

const API_URL = process.env.REACT_APP_API_URL;

function redirectToLoginWithExpiredSession() {
  const target = "/login?sessionExpired=1";
  if (
    window.location.pathname === "/login" &&
    window.location.search.includes("sessionExpired=1")
  ) {
    return;
  }

  window.location.replace(target);
}

function api_private_get(endpoint, successCallback) {
  fetch(API_URL + endpoint, {
    method: "GET",
    credentials: "include", // Include cookies
  })
    .then((response) => {
      if (response.status === 401) {
        // alert('You are not logged in. Redirecting to login page...');
        redirectToLoginWithExpiredSession();
        // React way
        // const navigate = useNavigate();
        // navigate('/login', {
        //     state: { errorMsg: 'You have been logged out due to inactivity. Please log in again.' }
        // });
      } else if (response.status !== 200) {
        console.error("Error:", response);
      }
      return response;
    })
    .then((response) => response.json())
    .then(successCallback)
    .catch((error) => {
      console.error("Error:", error);
    });
}

function api_private_post(
  endpoint,
  data,
  successCallback,
  errorCallback = null,
) {
  fetch(API_URL + endpoint, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((response) => {
      if (response.status === 401) {
        // alert('You are not logged in. Redirecting to login page...');
        redirectToLoginWithExpiredSession();
        // const navigate = useNavigate();
        // navigate('/login', {
        //     state: { errorMsg: 'You have been logged out due to inactivity. Please log in again.' }
        // });
      } else if (response.status !== 200) {
        console.error("Error:", response);
      }
      return response;
    })
    .then((response) => response.json())
    .then(successCallback)
    .catch((error) => {
      console.error("Error:", error);
      if (errorCallback) {
        errorCallback(error);
      }
    });
}

function formatStringAmountUSD(amt_string) {
  const amt = parseFloat(amt_string);
  const formattedNumber = amt.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return formattedNumber + " USD";
}

// The currently signed-in account's type ("credits" | "real"). Real accounts
// display their balance as real currency ($), credits accounts display "CR".
// AuthContext keeps this in sync with the logged-in user so the amount
// formatters below stay account-aware without prop-drilling.
let displayAccountType = "credits";

function setDisplayAccountType(accountType) {
  displayAccountType = accountType === "real" ? "real" : "credits";
}

function formatStringAmountCredits(
  amt_string,
  accountType = displayAccountType,
) {
  const amt = parseFloat(amt_string);
  const formattedNumber = amt.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return accountType === "real"
    ? "$" + formattedNumber
    : formattedNumber + " CR";
}

function formatUnixToLabel(unix) {
  const date = new Date(unix * 1000); // convert to ms
  const now = new Date();

  const isSameDay = (a, b) =>
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate();

  const tomorrow = new Date(now);
  tomorrow.setDate(now.getDate() + 1);

  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");

  const timeStr = `${hours}:${minutes}`;

  if (isSameDay(date, now)) {
    return `Today, ${timeStr}`;
  } else if (isSameDay(date, tomorrow)) {
    return `Tomorrow, ${timeStr}`;
  } else {
    const month = date.toLocaleString("en-US", { month: "long" }); // e.g., May
    const day = date.getDate();
    const suffix =
      day % 10 === 1 && day !== 11
        ? "st"
        : day % 10 === 2 && day !== 12
          ? "nd"
          : day % 10 === 3 && day !== 13
            ? "rd"
            : "th";

    if (date.getFullYear() === now.getFullYear()) {
      return `${month} ${day}${suffix}, ${timeStr}`;
    } else {
      return `${date.getFullYear()} ${month} ${day}${suffix}, ${timeStr}`;
    }
  }
}

/* ============================= */
/* Alerts                        */
/* ============================= */

const soundAlert_success = new Audio("/assets/sounds/mouse-clicks-6849-2.wav");
// const soundAlert_danger = new Audio("/assets/sounds/beep-6-96243-2.mp3");
const soundAlert_danger = new Audio("/assets/sounds/error-126627-1.mp3");
// const soundBeep1 = new Audio("/assets/sounds/beep-6-96243-2.mp3");

function showAlert(message, type) {
  const alert = document.getElementById("alert");

  // Check if alert element exists
  if (!alert) {
    console.warn("Alert element not found in DOM");
    console.log(message); // Log the message to console instead
    return;
  }

  alert.innerHTML = message;
  // alert.className = 'alert alert-fixed alert-' + type;
  alert.className = "alert alert-fixed custom-alert-" + type;
  alert.style.display = "block";

  // z-index to ensure it appears above other content
  alert.style.zIndex = "99999";

  if (type === "success") {
    soundAlert_success.play();
  } else if (type === "danger") {
    soundAlert_danger.play();
  }

  // Hide the alert after 5 seconds fading out
  setTimeout(() => {
    alert.classList.add("fade-out");
    setTimeout(() => {
      alert.style.display = "none";
      alert.classList.remove("fade-out");
    }, 1000);
  }, 3000);
}

export {
  api_private_get,
  api_private_post,
  formatStringAmountUSD,
  formatStringAmountCredits,
  setDisplayAccountType,
  formatUnixToLabel,
  showAlert,
  redirectToLoginWithExpiredSession,
};
